import { APP_NAME, ENV } from "@/utils/enum";

type Environment = ENV.prod | ENV.uat | ENV.dev;
type AppKey =
  | APP_NAME.VIBGYOR_VIVA
  | APP_NAME.VIBGYOR_ONE
  | APP_NAME.SUMMER_CAMP_PRIVATE;

type FeeMap = {
  [appName in AppKey]: {
    [env in Environment]: { [module: string]: number };
  };
};

export const FeeDescriptionMap: FeeMap = {
  VIBGYOR_VIVA: {
    prod: { VIBGYOR_VIVA: 18 },
    uat: { VIBGYOR_VIVA: 18 },
    dev: { VIBGYOR_VIVA: 18 },
  },
  VIBGYOR_ONE: {
    prod: {
      VEMBARK: 29,
      VIBGYOR_ONE: 13, //vibgyor_one refers to summercamp module
      EXTERNAL_EXAMINATION: 33,
      VIVA_CONCERT_KIT: 36,
      tours: 14,
      psa: 11,
      GI: 22,
      VC3: 30,
      vafp: 35,
    },
    uat: {
      VEMBARK: 29,
      VIBGYOR_ONE: 13,
      EXTERNAL_EXAMINATION: 32,
      VIVA_CONCERT_KIT: 36,
      tours: 14,
      psa: 11,
      GI: 22,
      VC3: 30,
      vafp: 35,
    },
    dev: {
      VEMBARK: 29,
      VIBGYOR_ONE: 13,
      EXTERNAL_EXAMINATION: 32,
      VIVA_CONCERT_KIT: 36,
      tours: 14,
      psa: 11,
      GI: 22,
      VC3: 30,
      vafp: 35,
    },
  },
  SUMMER_CAMP_PRIVATE: {
    prod: { SUMMER_CAMP_PRIVATE: 34, OLYMPIA_TOURS: 43 },
    uat: {
      SUMMER_CAMP_PRIVATE: 33,
      OLYMPIA_TOURS: 43,
    },
    dev: {
      SUMMER_CAMP_PRIVATE: 33,
      OLYMPIA_TOURS: 43,
    },
  },
};

export function getFeeDescription(module: string): number | undefined {
  const appName = process.env
    .NEXT_PUBLIC_APP_NAME as keyof typeof FeeDescriptionMap;
  console.log(
    JSON.stringify({
      message: `raw env for module ${module}:`,
      data: process.env.NEXT_PUBLIC_ENV,
    }),
  );
  const rawEnv =
    (process.env.NEXT_PUBLIC_ENV?.toLowerCase() as ENV) || ENV.prod;
  console.log("🚀 ~ getFeeDescription ~ rawEnv:", rawEnv);
  console.log(appName, "appNameec");
  const env: Environment = [ENV.prod, ENV.uat, ENV.dev].includes(rawEnv)
    ? (rawEnv as Environment)
    : ENV.uat;
  console.log("🚀 ~ getFeeDescription ~ env:", env);
  return FeeDescriptionMap[appName]?.[env]?.[module];
}

export function getAllFeeDescriptionByAPP() {
  const appName = process.env
    .NEXT_PUBLIC_APP_NAME as keyof typeof FeeDescriptionMap;
  console.log(
    JSON.stringify({
      message: `raw env for module ${module}:`,
      data: process.env.NEXT_PUBLIC_ENV,
    }),
  );
  const rawEnv = process.env.NEXT_PUBLIC_ENV?.toLowerCase() || ENV.prod;
  const env: Environment = ["prod", ENV.uat, ENV.dev].includes(rawEnv)
    ? (rawEnv as Environment)
    : ENV.uat;
  const allFees = FeeDescriptionMap[appName]?.[env];
  return allFees ? Object.values(allFees) : [];
}
